import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles/Footer.css";

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Pied de page</h2>
      
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">À propos</h3>
          <p className="footer-text">
            WinlyDeal est une plateforme innovante permettant de contribuer pour des produits à prix réduits. Le contributeur ayant donné le plus remporte le produit.
          </p>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">Liens rapides</h3>
          <ul className="footer-links">
            <li>
              <Link to="/" aria-current={location.pathname === '/' ? 'page' : undefined}>
                Accueil
              </Link>
            </li>
            <li>
              <Link to="/rules" aria-current={location.pathname === '/rules' ? 'page' : undefined}>
                Règles
              </Link>
            </li>
            <li>
              <Link to="/cgu" aria-current={location.pathname === '/cgu' ? 'page' : undefined}>
                CGU
              </Link>
            </li>
            <li>
              <Link to="/mentions-legales" aria-current={location.pathname === '/mentions-legales' ? 'page' : undefined}>
                Mentions Légales
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">Contactez-nous</h3>
          <p className="footer-text">Email : <a href="mailto:support@winlydeal.com">support@winlydeal.com</a></p>
          <p className="footer-text">Téléphone : <a href="tel:+33618156274">+33 6 18 15 62 74</a></p>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-bottom-text">&copy; 2025 WinlyDeal. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
